import React from 'react'
import * as pathUtil from 'path'
import InfraUtil from '../../Infra/InfraUtil'

function _imageURL(name, scale) {
  const rootURL = InfraUtil.rootURL()
  const filename = (scale > 1) ? name + '@' + scale + 'x' : name
  const completeFileName = filename + '.png'
  const path = pathUtil.join('images', completeFileName)
  return new URL(path, rootURL)
}

const Image = props => {
  const url1x = _imageURL(props.name, 1)
  const url2x = _imageURL(props.name, 2)
  const url3x = _imageURL(props.name, 3)
  return <img src={url1x} srcSet={`${url2x} 2x, ${url3x} 3x`} alt={props.alt} />
}

export default Image


// WEBPACK FOOTER //
// ./src/App/View/Image.js